/** Matches on the literals 'logout' / 'signout' or 'log-out' / 'sign-out' */
export function match(value: string) {
	return value === 'logout' || value === 'signout' || value === 'log-out' || value === 'sign-out';
}
